// @ts-nocheck
import React from 'react';
import styled from 'styled-components';

interface ITabPanelProps {
  tabValue: string;
  activeTab: string;
  children: React.ReactNode;
}

interface IRootProps {
  id: string;
  children?: React.ReactNode;
}

const TabPanel: React.FC<ITabPanelProps> = (props) => {
  const { tabValue, children } = props;
  return <Root id={tabValue}>{children}</Root>;
};

export default TabPanel;

const Root = styled.div<IRootProps>``;